import { render, staticRenderFns } from "./AtomsLabel.vue?vue&type=template&id=db7865f8&scoped=true&"
import script from "./AtomsLabel.vue?vue&type=script&lang=js&"
export * from "./AtomsLabel.vue?vue&type=script&lang=js&"
import style0 from "./AtomsLabel.vue?vue&type=style&index=0&id=db7865f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7865f8",
  null
  
)

export default component.exports